import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

import { AiOutlineSearch } from "react-icons/ai";
import Spinner from '../../../../../components/Spinner'
import { Header, TableWrapper, TableSection, SearchWrapper } from '../../DashBoard/dashBoardStyled'
//table
import { Table } from 'reactstrap';
import { MdKeyboardBackspace } from "react-icons/md";
import Pagination from '@material-ui/lab/Pagination';
import { showAppLoader, hideAppLoader } from '../../../../../../redux/actions/app';
import axioPath from '../../../../../../api/axioPath';

function OrderReport({ downloadReportCSV, isDownloadingOrderReportCSV }) {
    let history = useHistory();
    let location = useLocation();
    const dispatch = useDispatch();
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [dataList, setDataList] = useState([]);
    const [finalData, setFinalData] = useState([])
    const [csvData, setCsvData] = useState([])
    const [searching, setSearching] = useState("");
    const [searchKey, setSearchKey] = useState("");
    const [searchKeyTimeout, setSearchKeyTimeout] = useState(null);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [tableSearch, setTableSearch] = useState('')
    const [headerArray, setHeaderArray] = useState([
        { title: 'Order Id', },
        { title: 'PO Number', },
        { title: 'Buyer', },
        { title: 'Buyer City', },
        { title: 'Buyer State', },
        { title: 'Buyer Zip', },
        { title: 'Buyer Broker', },
        { title: 'Buyer FC Member', },
        { title: 'Seller', },
        { title: 'Seller City', },
        { title: 'Seller State', },
        { title: 'Seller Zip', },
        { title: 'Seller Broker', },
        { title: 'Seller FC Member', },
        { title: 'Post Name', },
        { title: 'Transport Type', },
        { title: 'Requested Date', },
        { title: 'Actual Delivery Date', },
        { title: 'Quantity', },
        { title: 'Unit Price', },
        { title: 'Order Type', },
        { title: 'Status', }
    ])

    const [filterData, setFilterData] = useState({});

    const getActualQuantityFunc = val => {
        let actualDisplayQuantity = val.orderDetails?.quantity
        let totalClaimQuantity = 0
        if (val.claimDetails?.length > 0) {
            totalClaimQuantity = val.claimDetails.reduce((acc, value) => {
                return acc + value.claimQuantity + value.claimQuality
            }, 0)
        }
        actualDisplayQuantity = actualDisplayQuantity - totalClaimQuantity
        return actualDisplayQuantity
    }

    useEffect(() => {
        if (location.state !== null && location.state !== undefined) {
            let filterDataTemp = location.state.filter
            setFilterData(location.state.filter)
            dispatch(showAppLoader());
            const token = localStorage.getItem("token")
            let url = `order/admin/order_report?month=${filterDataTemp.month}&year=${filterDataTemp.year}&userType=${filterDataTemp.userType}&city=${filterDataTemp.city}&state=${filterDataTemp.state}&size=10&sort=DESC&page=${page}&searchBy=${searchKey}`
            axioPath.get(url, {
                headers: {
                    Authorization: token,
                    companyName: filterDataTemp.companyName,
                    ...(filterDataTemp.status !== 'All' && { orderStatus: filterDataTemp.status })
                },
            }).then((response) => {
                if (response.data.status === 'SUCCESS') {
                    if (response.data.payload) {
                        let userSubList = response.data.payload
                        let tempData1 = Object.values(userSubList)
                        let initialData = Object.values(tempData1[0])
                        // const sotrtedTempData = getsortedTempData(initialData)
                        let tempDataSorted = initialData.flat().sort((a, b) => b.created - a.created)

                        if (initialData !== null) setDataList(tempDataSorted)
                        //pagination
                        let pageData = JSON.parse(JSON.stringify(tempDataSorted))
                        setFinalData(pageData)
                        const totalPages = userSubList?.pageableDTO?.totalPages ?? 1;
                        setPageCount(totalPages ?? 1)
                    }
                } else {
                    if (response.data.message === "Unauthorized (Invalid token)") {
                        history.push('/sign-in')
                        window.location.reload(false);
                    } else {
                        setModalContent(response.data.message)
                        setModal(!modal)
                    }
                }
            }).catch((ex) => {
                if (ex.response?.status === 401) {
                    history.push('./sign-in')
                    window.location.reload(false)
                } else {
                    setModalContent(ex.response?.data?.message || ex.message)
                    setModal(!modal)
                }
            }).finally(() => {
                dispatch(hideAppLoader());
            })
        } else {
            history.push({
                pathname: '/reports',
                state: { page: 'order' }
            })
        }
    }, [page, searchKey]);

    // filter data based on the search field
    const filterSearchDataFunction = (search, dataList) => {
        let tempData = dataList.filter(value => {
            return (
                (value.id?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo?.companyName?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.sellerInfo?.companyName?.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderDetails && value.orderDetails.quantity !== null && value.orderDetails.quantity.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo && value.buyerInfo.price && value.buyerInfo.price.productPrice && value.buyerInfo.price.productPrice.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo && value.buyerInfo.city !== null && value.buyerInfo.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.buyerInfo && value.buyerInfo.state !== null && value.buyerInfo.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.sellerInfo && value.sellerInfo.city !== null && value.sellerInfo.city.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.sellerInfo && value.sellerInfo.state !== null && value.sellerInfo.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.contactInfo && value.contactInfo.requestedDate && moment(value.contactInfo.requestedDate).format("MM/DD/YYYY").toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderStatus && value.orderStatus.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.poNumber && value.poNumber.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.orderDetails?.title?.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        return tempData
    }

    const handleChange = (event, value) => {
        setPage(value);
        const search = tableSearch
        let dataListtemp = filterSearchDataFunction(search, dataList)
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    const handleSearchChangeFromService = (e) => {
        let searchVal = e.target.value
        setSearching(searchVal)
        if (searchKeyTimeout) clearTimeout(searchKeyTimeout)
        const t = setTimeout(() => setSearchKey(searchVal), 1000)
        setSearchKeyTimeout(t)
        setPage(1)
    }

    return (
        <TableWrapper>
            {loaderVisible && <Spinner />}
            <MdKeyboardBackspace style={{ width: '28px', height: '28px', position: 'relative', left: '12px', top: '8px', cursor: 'pointer' }}
                onClick={() => {
                    history.push({
                        pathname: '/reports',
                        state: { page: 'order' }
                    })
                }} />
            <Header>
                <h3>Order Report</h3>
                <div className='action-wrapper'>
                    <SearchWrapper>
                        <input style={{ border: '1px solid #87CDF1', borderRadius: '5px' }} type="text" placeholder='Search' value={searching}
                            onChange={handleSearchChangeFromService} />
                        <AiOutlineSearch />
                    </SearchWrapper>
                    <button
                        // onClick={() => handleCsvExportClick(1)}
                        disabled={isDownloadingOrderReportCSV}
                        onClick={() => {
                            downloadReportCSV(filterData, 1, searchKey)
                        }}
                        style={{ background: isDownloadingOrderReportCSV ? '#b2afac' : '#27911b', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px' }}>
                        {isDownloadingOrderReportCSV ? "Exporting..." : "Export"}
                    </button>
                </div>
            </Header>
            <TableSection>
                <Table responsive>
                    <thead>
                        <tr>
                            {headerArray.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            finalData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.id}</td>
                                    <td>{items.poNumber ? items.poNumber : 'NA'}</td>
                                    <td>{items.buyerInfo.companyName}</td>
                                    <td>{items.buyerInfo.city}</td>
                                    <td>{items.buyerInfo.state}</td>
                                    <td>{items.buyerInfo?.address?.zip}</td>
                                    <td>{items.buyerIsReseller ? 'Yes' : 'No'}</td>
                                    <td>{items.buyerInnerCircle ? 'Yes' : 'No'}</td>
                                    <td>{items.sellerInfo.companyName}</td>
                                    <td>{items.sellerInfo.city}</td>
                                    <td>{items.sellerInfo.state}</td>
                                    <td>{items.sellerInfo?.address?.zip}</td>
                                    <td>{items.sellerIsReseller ? 'Yes' : 'No'}</td>
                                    <td>{items.sellerInnerCircle ? 'Yes' : 'No'}</td>
                                    <td title={items.orderDetails?.title} style={{ minWidth: '175px', whiteSpace: 'nowrap' }}>
                                        {items.orderDetails?.title?.substring(0, 25)}
                                        {items.orderDetails?.title?.length > 25 && <span>...</span>}</td>
                                    <td>{items.contactInfo?.type === "DELIVERABLE" ? "Delivery" : "Pickup"}</td>
                                    <td>{moment(items.contactInfo.requestedDateUTC * 1000).format("MM/DD/YYYY")}</td>
                                    <td>{items.buyerDeliveryDate ? moment(items.buyerDeliveryDate).format("MM/DD/YYYY") : 'NA'}</td>
                                    <td>{getActualQuantityFunc(items)}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>$ {items.orderDetails?.pricePerPallet?.toFixed(2)}</td>
                                    <td>{items.orderDetails?.postType === "LOAD" ? "Need" : "Inventory"}</td>
                                    <td>{items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}</td>
                                </tr>
                            ))}
                        {finalData.length === 0 &&
                            <p style={{ position: 'absolute', width: '100%', textAlign: 'center', marginTop: '30px' }}>No records found</p>
                        }
                    </tbody>
                </Table>
            </TableSection>
            {dataList.length !== 0 && <Pagination count={pageCount}
                page={page}
                onChange={handleChange} />}

        </TableWrapper>

    )
};

export default OrderReport;